import { Link } from "react-router-dom";

export default function HowItWorksSection() {
  const steps = [
    {
      number: "01",
      title: "Access the AllChinaBuy Spreadsheet",
      description: "Open the structured spreadsheet dashboard that organizes all verified China supplier data in one place.",
      icon: "ri-database-2-line",
    },
    {
      number: "02",
      title: "Filter Suppliers by Category",
      description: "Browse categories like shoes, clothing, electronics, and accessories to find exactly what you need.",
      icon: "ri-filter-3-line",
    },
    {
      number: "03",
      title: "Compare Agents Side-by-Side",
      description: "View pricing, shipping options, and reliability ratings across multiple agents simultaneously.",
      icon: "ri-scales-line",
    },
    {
      number: "04",
      title: "Select and Process Your Order",
      description: "Choose the best supplier and redirect to the main platform for seamless order processing.",
      icon: "ri-shopping-cart-2-line",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            How It Works
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Simple 4-Step Sourcing Process
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Get from product discovery to order placement in minutes with our streamlined workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step) => (
            <div key={step.number} className="relative bg-background-50 rounded-2xl p-6 border border-background-200/70">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${step.icon} text-primary-600 text-xl`}></i>
              </div>
              <div className="absolute top-4 right-4 text-4xl font-heading font-bold text-background-300 select-none">
                {step.number}
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            Read detailed sourcing guide
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}